import { Link } from "react-router-dom";
import { Box, Button, Chip, Skeleton, Stack, Typography } from "@mui/material";

interface PermissionBoxProps {
  hasPermission: boolean;
  settingsLink: string;
  name: string;
  loading?: boolean;
  logoSrc?: string;
}

const PermissionBox = ({ hasPermission, settingsLink, name, logoSrc, loading = false }: PermissionBoxProps) => {
  const renderContent = () => {
    if (loading) {
      return <Skeleton variant="rectangular" width="100%" height={30} animation="wave" />;
    }

    if (hasPermission) {
      return <Chip label="Connected" variant="status" size="small" color="success" sx={{ width: "fit-content" }} />;
    }

    return (
      <Button size="small" component={Link} to={settingsLink} variant="outlined" sx={{ width: "fit-content" }}>
        Add
      </Button>
    );
  };

  return (
    <Stack
      spacing={1}
      p={1}
      width="100%"
      sx={{ backgroundColor: "general.backgroundDark" }}
      borderRadius="4px"
      alignContent="space-between"
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <img src={logoSrc} height={24} alt={`${name} logo`} title={`${name} logo`} />
        <Typography variant="body2">{name} permissions</Typography>
      </Stack>
      <Box flexGrow={1} display="flex" alignItems="center">
        {renderContent()}
      </Box>
    </Stack>
  );
};

export default PermissionBox;
